import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  lat: number
  lng: number
  onClick: () => void
}

const EditLocationButton = ({ lat, lng, onClick }: Props) => {
  return (
    <>
      <Button type="secondary" onClick={onClick} iconName="pencil">
        {i18n.t('settings.locations.map.edit_button')}
      </Button>
    </>
  )
}

export default EditLocationButton
